module.exports = __webpack_public_path__ + "img/asm-jiansuqi.asm.097d83e9.jpg";